exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oodrive-body {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  background-color: #f8f9fb;\n}\n.oodrive-body .oodrive-title {\n    color: rgba(6, 38, 62, 0.74);\n    font-size: 2rem;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n}\n.oodrive-body .oodrive-sub-title {\n    margin-top: -6px;\n    margin-left: 2px;\n    color: rgba(6, 38, 62, 0.54);\n    letter-spacing: 0.05em;\n    font-size: 0.95rem;\n}\n", ""]);

// exports
